const semanticClassNames = {
  root: 'google-map',
} as const;

export default semanticClassNames;
